import { Amount } from '@mews-commander/data-access';
import { Amount as OldAmount } from '@mews-commander/types';

export type MaybeAmount = Amount | OldAmount | null | undefined;

export const getChargedCurrencyAmount = (amount: MaybeAmount): Amount | null => {
    const { source } = amount || {};

    if (!amount || !source) {
        return null;
    }

    if (!source.source) {
        return source as Amount;
    }

    return getChargedCurrencyAmount(source);
};

export const getAccountingCurrencyAmount = (amount: MaybeAmount): Amount | null => {
    const { source } = amount || {};

    if (!amount || !source) {
        return null;
    }

    if (amount.currency === source.currency) {
        return null;
    }

    return source as Amount;
};

export const findOriginalAmount = (amount: Amount | OldAmount | null | undefined) => {
    const { source } = amount || {};

    if (!source) {
        return amount;
    }

    return getChargedCurrencyAmount(amount);
};

export const getCurrencyValue = ({ amount, net = false }: { amount?: MaybeAmount; net?: boolean } = {}) => {
    const { grossValue, netValue, currency } = amount || {};

    return {
        value: net ? netValue : grossValue,
        currency,
    };
};
